module.exports = __webpack_public_path__ + "img/headphones.b6fa6229.svg";